<div
  [attr.data-automation-id]="automationId"
  class="timeline-item-contents position-relative mt-n9"
>
  <div
    class="timeline-item-icon float-start mt-4 ms-4 fill-white stroke-white icon-size-medium"
  >
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4162_839)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M50 20H46V38H20V42C20 42.5304 20.2107 43.0391 20.5858 43.4142C20.9609 43.7893 21.4696 44 22 44H44L52 52V22C52 21.4696 51.7893 20.9609 51.4142 20.5858C51.0391 20.2107 50.5304 20 50 20ZM42 32V14C42 13.4696 41.7893 12.9609 41.4142 12.5858C41.0391 12.2107 40.5304 12 40 12H14C13.4696 12 12.9609 12.2107 12.5858 12.5858C12.2107 12.9609 12 13.4696 12 14V42L20 34H40C40.5304 34 41.0391 33.7893 41.4142 33.4142C41.7893 33.0391 42 32.5304 42 32Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4162_839">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(8 8)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
  <div class="timeline-item-text me-4 ms-11 pt-4 text-white">
    <digital-platform-rsx-rich-text
      [body]="itemText ?? ''"
    ></digital-platform-rsx-rich-text>
  </div>
</div>
